import { DataField } from '@/components/data/dataType';
import { DataFieldType } from './DataFieldType';

export const imageFields: DataField[] = [
    {
        name: 'id',
        i18n: false,
        title: { fr: 'Id', en: 'Id' },
        defaultValue: 0,
        dataType: DataFieldType.Key,
        required: true,
        gridClass: '',
    },
    {
        name: 'title',
        i18n: true,
        title: { fr: 'Titre', en: 'Title' },
        defaultValue: null,
        dataType: DataFieldType.String,
        required: false,
        gridClass: 'col-span-full',
    },
    {
        name: 'link',
        i18n: true,
        title: { fr: 'Lien', en: 'Link' },
        defaultValue: null,
        dataType: DataFieldType.String,
        required: true,
        gridClass: 'col-span-full',
        tableVisible: false,
    },
    {
        name: 'position',
        i18n: false,
        title: { fr: 'Position', en: 'Position' },
        defaultValue: null,
        dataType: DataFieldType.SortNumber,
        required: false,
        gridClass: 'col-span-1',
        tableVisible: true,
    },
];
